/**
 * Drawer
 */

import {
	lockBodyScrolling,
	unlockBodyScrolling
} from '../../../../shared/utils/scroll';

import SelectorEngine from '../../../../shared/dom/selector-engine';
import Manipulator from '../../../../shared/dom/manipulator';
import EventHandler from '../../../../shared/dom/event-handler';

import Drawer from '../../../../shared/components/drawer';
import {isElement} from '../../../../shared/utils/is';

// -------
// Private
// -------

const setupDrawer = (element) => {
	const trigger  = element;
	const id       = Manipulator.getDataAttribute(trigger, 'drawer-trigger');
	const drawerEl = SelectorEngine.findOne(`${id}`);
	const drawer   = new Drawer(drawerEl, {
		closeButton: 0,
		onShow     : function() {
			Manipulator.addClass(trigger, '-active');
		},
		onHidden   : () => {
			Manipulator.removeClass(trigger, '-active');
		}
	});

	EventHandler.on(trigger, 'click.ifab.customDrawer', (event) => {
		event.preventDefault();
		event.stopPropagation();

		if (event.delegateTarget.classList.contains('-active')) {
			drawer.hide();
		} else {
			drawer.show();
		}
	});
};

// -------
// Public
// -------

const init = () => {
	const collection = SelectorEngine.find('[data-drawer-trigger]');

	if(!collection.length) {
		return;
	}

	for (const element of collection) {
		setupDrawer(element);
	}
};

// -------
// Exports
// -------

export default init;